import { useEffect, useRef, useState } from "react";
import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import { useSelector } from "react-redux";
import { notAvailableImg } from "../../constants/common-constants";
import SVGSelector from "../common-components/SVGSelector";
import { getEdgeClass } from "../../utils";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const VehicleDetailsZoomableImageModal = ({
  isVisible,
  handleModalToggle,
  vehicleDetails = [],
  selectedIndex,
  setSelectedIndex,
}) => {
  const { edge = false } = useSelector((state) => state?.uiConfig) || {};

  // Lock body scroll when modal is visible
  useEffect(() => {
    if (isVisible) {
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
    } else {
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
    return () => {
      if (isVisible) {
        const scrollY = document.body.style.top;
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
      }
    };
  }, [isVisible]);

  const swiperRef = useRef(null);

  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [swiperInstance, setSwiperInstance] = useState(null);

  useEffect(() => {
    if (!swiperInstance) return;

    const updateNavState = () => {
      setIsBeginning(swiperInstance.isBeginning);
      setIsEnd(swiperInstance.isEnd);
    };

    swiperInstance.on("transitionEnd", updateNavState);
    updateNavState();

    return () => {
      swiperInstance.off("transitionEnd", updateNavState);
    };
  }, [swiperInstance, vehicleDetails]);

  return (
    <>
      {isVisible ? (
        <div
          aria-hidden="true"
          className={`${
            isVisible ? "flex" : "hidden"
          } fixed inset-0 bg-[#0000005e] z-50 justify-center items-center w-full h-full overflow-hidden`}
        >
          <div className="relative w-full h-full overflow-hidden">
            <div
              className={`${getEdgeClass(edge)} bg-[var(--white-shade)] shadow p-1 w-full h-full flex flex-col items-center overflow-hidden`}
            >
              <div className="relative flex-grow container overflow-hidden">
                <button
                  type="button"
                  className={`${getEdgeClass(edge)} absolute top-[5.5rem] right-4 text-sm w-8 h-8 inline-flex justify-center items-center z-10 bg-[var(--text-white-black)]`}
                  onClick={handleModalToggle}
                  aria-label="Close"
                >
                  <SVGSelector
                    name="cross-svg"
                    svgHeight={16}
                    svgWidth={16}
                    pathStroke={"var(--secondary-color)"}
                  />
                </button>

                <Swiper
                  ref={swiperRef}
                  modules={[Navigation]}
                  initialSlide={selectedIndex}
                  onSlideChange={(swiper) =>
                    setSelectedIndex(swiper.activeIndex)
                  }
                  onSwiper={setSwiperInstance}
                  navigation={{
                    nextEl: ".thumbnail-swiper-next-btn",
                    prevEl: ".thumbnail-swiper-prev-btn",
                    disabledClass: "swiper-button-disabled",
                  }}
                  className="w-full h-full overflow-hidden flex"
                >
                  {vehicleDetails?.map((item, index) => (
                    <SwiperSlide key={index}>
                      <div className="w-full h-full flex items-center justify-center overflow-hidden">
                        <InnerImageZoom
                          src={
                            item?.downloadUrl + "&w=1150&h=1000&q=80" ||
                            notAvailableImg
                          }
                          zoomSrc={
                            item?.downloadUrl + "&q=100" || notAvailableImg
                          }
                          className={`${getEdgeClass(edge, "rounded-lg")} max-w-full max-h-full object-contain !block`}
                          alt={`Vehicle ${index + 1}`}
                          onError={(e) => {
                            e.target.src = notAvailableImg;
                          }}
                          zoomType="click"
                          zoomPreload={false}
                          onClick={handleModalToggle}
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
                <button
                  className={`thumbnail-swiper-prev-btn ${isBeginning ? "swiper-button-disabled" : ""} !h-auto`}
                  disabled={isBeginning}
                  onClick={() => {
                    const swiper = swiperRef.current?.swiper;
                    if (swiper && !isBeginning) {
                      swiper.slidePrev();
                    }
                  }}
                  aria-label="Previous Slide"
                  aria-disabled={isBeginning}
                >
                  <SVGSelector
                    name="arrow-left-svg"
                    pathFill={"var(--text-white-black)"}
                    aria-hidden="true"
                  />
                </button>
                <button
                  className={`thumbnail-swiper-next-btn ${isEnd ? "swiper-button-disabled" : ""} !h-auto`}
                  disabled={isEnd}
                  onClick={() => {
                    const swiper = swiperRef.current?.swiper;
                    if (swiper && !isEnd) {
                      swiper.slideNext();
                    }
                  }}
                  aria-label="Next Slide"
                  aria-disabled={isEnd}
                >
                  <SVGSelector
                    name="arrow-right-svg"
                    pathFill={"var(--text-white-black)"}
                    aria-hidden="true"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
export default VehicleDetailsZoomableImageModal;
